import { useStore } from '@/app/providers/store';

export type NexusKey = 'isSubOneTimeOffer' | 'isMissionWatchAdCredit' | 'isClawPassBundleFirstPurchase';

/**
 * 通过 nexus 规则判断当前用户是否符合特定条件。
 */
export const useUserNexus = (): Record<NexusKey, boolean> => {
  const availableNexus = useStore((state) => state.availableNexus);

  return {
    /** 是否可以享受首次订阅优惠 */
    isSubOneTimeOffer: availableNexus.includes('sub_one_time_offer'),
    /** 是否有看广告得积分资格 */
    isMissionWatchAdCredit: availableNexus.includes('mission_watch_ad_credit'),
    /** 是否可以享受创作者计划捆绑套餐首购优惠 */
    isClawPassBundleFirstPurchase: availableNexus.includes('claw_pass_bundle_first_purchase'),
  };
};
